var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptionLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 280.332,
    viewBox: "0 0 272 280.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Waiting-for-prescription",
    transform: "translate(0.015 2.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(-0.015 -2.101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 33.635,
    height: 64.19,
    rx: 5.21,
    transform: "translate(40.177 0) rotate(38.06)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M57.853,115.778c-.037.037-3.525-2.636-7.792-5.978s-7.7-6.088-7.671-6.13,3.519,2.636,7.792,5.978S57.883,115.736,57.853,115.778Z",
    transform: "translate(-32.531 -52.562)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M110.943,45.038c-.037.043-3.525-2.636-7.792-5.978s-7.707-6.088-7.671-6.13,3.519,2.636,7.792,5.978S110.973,45,110.943,45.038Z",
    transform: "translate(-53.301 -24.887)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M54.37,85.654c-.043-.037,7.342-9.533,16.486-21.21S87.451,43.32,87.494,43.35s-7.336,9.527-16.486,21.21S54.412,85.685,54.37,85.654Z",
    transform: "translate(-37.218 -28.964)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M87.88,46.456l1.942-2.606,2.435,1.826a1.619,1.619,0,0,1,.329,2.271h0a1.625,1.625,0,0,1-2.271.335Z",
    transform: "translate(-50.328 -29.159)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M88.544,43,86.6,45.6l-2.435-1.826A1.632,1.632,0,0,1,83.8,41.5h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-48.611 -27.985)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M108.54,62.236l1.942-2.606,2.435,1.826a1.632,1.632,0,0,1,.335,2.277h0a1.632,1.632,0,0,1-2.277.329Z",
    transform: "translate(-58.41 -35.333)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M109.218,58.782l-1.942,2.606-2.435-1.826a1.619,1.619,0,0,1-.329-2.271h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-56.708 -34.162)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M78.93,58.256l1.942-2.606,2.435,1.826a1.632,1.632,0,0,1,.335,2.277h0a1.632,1.632,0,0,1-2.277.329Z",
    transform: "translate(-46.826 -33.776)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M79.6,54.8l-1.936,2.606-2.435-1.826a1.619,1.619,0,0,1-.329-2.271h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-45.124 -32.605)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M100.06,74.38,102,71.78l2.435,1.826a1.625,1.625,0,0,1,.335,2.271h0a1.625,1.625,0,0,1-2.277.335Z",
    transform: "translate(-55.093 -40.086)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M100.772,70.931l-1.936,2.606L96.4,71.71a1.619,1.619,0,0,1-.329-2.271h0a1.625,1.625,0,0,1,2.271-.335Z",
    transform: "translate(-53.406 -38.915)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M70,70.046l1.942-2.606,2.435,1.826a1.619,1.619,0,0,1,.329,2.271h0a1.625,1.625,0,0,1-2.271.335Z",
    transform: "translate(-43.333 -38.388)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M70.645,66.627,68.7,69.232l-2.435-1.826a1.619,1.619,0,0,1-.335-2.271h0a1.625,1.625,0,0,1,2.252-.335Z",
    transform: "translate(-41.616 -37.234)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M91.58,86.526l1.936-2.606,2.435,1.826a1.619,1.619,0,0,1,.329,2.271h0a1.625,1.625,0,0,1-2.271.335Z",
    transform: "translate(-51.775 -44.836)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M92.237,83.077,90.3,85.682,87.86,83.856a1.625,1.625,0,0,1-.353-2.277h0a1.632,1.632,0,0,1,2.277-.335Z",
    transform: "translate(-50.058 -43.664)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M59.82,82.166l1.936-2.606,2.435,1.826a1.619,1.619,0,0,1,.329,2.271h0a1.619,1.619,0,0,1-2.271.329Z",
    transform: "translate(-39.35 -43.13)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M60.491,78.709l-1.942,2.606-2.435-1.826a1.632,1.632,0,0,1-.323-2.277h0a1.632,1.632,0,0,1,2.277-.329Z",
    transform: "translate(-37.647 -41.957)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M81.6,98.4l1.942-2.606,2.435,1.826a1.619,1.619,0,0,1,.335,2.271h0a1.619,1.619,0,0,1-2.271.329Z",
    transform: "translate(-47.871 -49.479)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M82.279,94.944l-1.942,2.6L77.9,95.717a1.632,1.632,0,0,1-.329-2.277h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-46.169 -48.305)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M50.84,95.816l1.924-2.606L55.2,95.036a1.632,1.632,0,0,1,.329,2.277h0a1.619,1.619,0,0,1-2.271.329Z",
    transform: "translate(-35.837 -48.47)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M51.516,92.358l-1.942,2.593-2.435-1.826a1.625,1.625,0,0,1-.341-2.265h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-34.133 -47.296)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M71.57,111.256l1.942-2.606,2.435,1.826a1.619,1.619,0,0,1,.335,2.271h0a1.619,1.619,0,0,1-2.271.329Z",
    transform: "translate(-43.947 -54.511)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M72.249,107.8,70.307,110.4l-2.435-1.826a1.632,1.632,0,0,1-.329-2.277h0a1.619,1.619,0,0,1,2.271-.329Z",
    transform: "translate(-42.245 -53.336)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M424.1,246.028l-39.108,13.326a3.172,3.172,0,0,1-4.024-1.985L353.69,177.291a3.172,3.172,0,0,1,1.979-4.03l39.108-13.32a3.172,3.172,0,0,1,4.024,1.979L426.08,242a3.166,3.166,0,0,1-1.979,4.024Z",
    transform: "translate(-154.251 -74.51)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M382.057,198.623a3.488,3.488,0,1,1-4.426-2.173,3.488,3.488,0,0,1,4.426,2.173Z",
    transform: "translate(-162.759 -88.786)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M413.563,187.893a3.482,3.482,0,1,1-4.42-2.173,3.482,3.482,0,0,1,4.42,2.173Z",
    transform: "translate(-175.089 -84.589)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M392.033,227.913a3.476,3.476,0,1,1-1.759-2,3.482,3.482,0,0,1,1.759,2Z",
    transform: "translate(-166.666 -100.245)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M423.543,217.183a3.482,3.482,0,1,1-4.42-2.173A3.482,3.482,0,0,1,423.543,217.183Z",
    transform: "translate(-178.993 -96.047)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M402.013,257.213a3.482,3.482,0,1,1-4.42-2.173A3.482,3.482,0,0,1,402.013,257.213Z",
    transform: "translate(-170.571 -111.708)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M433.523,246.483a3.482,3.482,0,1,1-4.42-2.173,3.482,3.482,0,0,1,4.42,2.173Z",
    transform: "translate(-182.898 -107.51)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M411.993,286.483a3.482,3.482,0,1,1-4.42-2.173,3.482,3.482,0,0,1,4.42,2.173Z",
    transform: "translate(-174.475 -123.159)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M443.5,275.773a3.482,3.482,0,1,1-4.42-2.173A3.482,3.482,0,0,1,443.5,275.773Z",
    transform: "translate(-186.802 -118.969)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M381.441,197.07a19.817,19.817,0,0,1-1.364,2.983,18.877,18.877,0,0,1-1.607,2.861,19.813,19.813,0,0,1,1.364-2.983A18.629,18.629,0,0,1,381.441,197.07Z",
    transform: "translate(-164.012 -89.102)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M412.295,186.3a19.708,19.708,0,0,1-1.358,2.989,19.918,19.918,0,0,1-1.607,2.861,20.02,20.02,0,0,1,1.358-2.989A20.341,20.341,0,0,1,412.295,186.3Z",
    transform: "translate(-176.085 -84.889)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M391.9,226.36a20.655,20.655,0,0,1-1.218,3.135,19.926,19.926,0,0,1-1.461,3.044,21.213,21.213,0,0,1,1.218-3.135,20.285,20.285,0,0,1,1.461-3.044Z",
    transform: "translate(-168.218 -100.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M423.242,215.56a18.366,18.366,0,0,1-1.035,3.044,19.05,19.05,0,0,1-1.3,2.953,18.577,18.577,0,0,1,1.035-3.044A19.738,19.738,0,0,1,423.242,215.56Z",
    transform: "translate(-180.616 -96.336)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M401.1,255.53a34.09,34.09,0,0,1-2.435,5.637,34.086,34.086,0,0,1,2.435-5.637Z",
    transform: "translate(-171.911 -111.973)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M433.06,245.29a35.057,35.057,0,0,1-2.91,5.516,17.127,17.127,0,0,1,1.333-2.819,18.354,18.354,0,0,1,1.577-2.7Z",
    transform: "translate(-184.23 -107.967)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M411.479,285.24a19.41,19.41,0,0,1-1.443,2.928,19.174,19.174,0,0,1-1.686,2.794,38.351,38.351,0,0,1,3.129-5.723Z",
    transform: "translate(-175.702 -123.596)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M443.2,273.56a22.847,22.847,0,0,1-1.218,3.342,22.466,22.466,0,0,1-1.473,3.233,22.776,22.776,0,0,1,1.218-3.342,22.089,22.089,0,0,1,1.473-3.233Z",
    transform: "translate(-188.283 -119.027)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M439.5,293c0,.073-5.85,2.137-13.119,4.615s-13.192,4.426-13.217,4.353,5.85-2.137,13.125-4.615S439.471,292.913,439.5,293Z",
    transform: "translate(-177.584 -126.63)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M396.676,175.209c0,.067-5.85,2.137-13.125,4.615s-13.186,4.426-13.211,4.353,5.85-2.137,13.125-4.615S396.651,175.136,396.676,175.209Z",
    transform: "translate(-160.832 -80.549)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M392.5,188.4a.2.2,0,0,1-.1,0h-.037l.268-.085h0a.111.111,0,0,1-.1.128c-.1.024-.146,0-.164-.043h0l.268-.085h0v.037a.164.164,0,0,1-.134.049Z",
    transform: "translate(-169.446 -85.675)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M417.546,254.285c-.073,0-5.625-16.084-12.407-35.979S392.927,182.254,393,182.23s5.625,16.084,12.4,35.985S417.619,254.261,417.546,254.285Z",
    transform: "translate(-169.696 -83.296)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M0,0H31.425V61.42A3.823,3.823,0,0,1,27.6,65.243H3.823A3.823,3.823,0,0,1,0,61.42Z",
    transform: "translate(102.929 275.996) rotate(-86.19)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 19.749,
    height: 28.235,
    transform: "translate(120.791 277.183) rotate(-86.19)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 37.769,
    height: 10.909,
    rx: 2.1,
    transform: "translate(96.894 279.226) rotate(-86.19)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M196.549,474.185a44.573,44.573,0,0,1-5.479-.195,45.052,45.052,0,0,1-5.43-.53,44.561,44.561,0,0,1,5.479.195A44.87,44.87,0,0,1,196.549,474.185Z",
    transform: "translate(-88.573 -197.226)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M196.9,469.186a43.031,43.031,0,0,1-5.449-.195,44.864,44.864,0,0,1-5.43-.53,45.973,45.973,0,0,1,5.449.195,44.876,44.876,0,0,1,5.43.53Z",
    transform: "translate(-88.722 -195.271)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M197.219,464.195A44.566,44.566,0,0,1,191.74,464a44.878,44.878,0,0,1-5.43-.53,44.567,44.567,0,0,1,5.479.195A45.057,45.057,0,0,1,197.219,464.195Z",
    transform: "translate(-88.835 -193.317)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M197.549,459.2A44.567,44.567,0,0,1,192.07,459a44.883,44.883,0,0,1-5.43-.53,46.077,46.077,0,0,1,5.479.195A44.882,44.882,0,0,1,197.549,459.2Z",
    transform: "translate(-88.964 -191.362)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M197.895,454.2a44.423,44.423,0,0,1-5.449-.195,45.033,45.033,0,0,1-5.436-.53,44.585,44.585,0,0,1,5.479.195A44.887,44.887,0,0,1,197.895,454.2Z",
    transform: "translate(-89.109 -189.409)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M198.219,449.206a44.542,44.542,0,0,1-5.479-.195,44.877,44.877,0,0,1-5.43-.53,45.968,45.968,0,0,1,5.479.195,45.057,45.057,0,0,1,5.43.53Z",
    transform: "translate(-89.227 -187.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M198.549,444.215a44.566,44.566,0,0,1-5.479-.195,44.876,44.876,0,0,1-5.43-.53,44.579,44.579,0,0,1,5.479.195A45.057,45.057,0,0,1,198.549,444.215Z",
    transform: "translate(-89.356 -185.501)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M198.879,439.216a44.573,44.573,0,0,1-5.479-.195,45.045,45.045,0,0,1-5.43-.53,46.077,46.077,0,0,1,5.479.195A44.882,44.882,0,0,1,198.879,439.216Z",
    transform: "translate(-89.485 -183.546)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M199.229,434.225a44.447,44.447,0,0,1-5.449-.195,44.883,44.883,0,0,1-5.43-.53,44.44,44.44,0,0,1,5.479.195A44.88,44.88,0,0,1,199.229,434.225Z",
    transform: "translate(-89.633 -181.592)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M199.549,429.226a44.573,44.573,0,0,1-5.479-.195,44.877,44.877,0,0,1-5.43-.53,46.1,46.1,0,0,1,5.479.195A45.051,45.051,0,0,1,199.549,429.226Z",
    transform: "translate(-89.747 -179.638)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M199.879,424.235a44.567,44.567,0,0,1-5.479-.195,44.871,44.871,0,0,1-5.43-.53,44.573,44.573,0,0,1,5.479.195,44.876,44.876,0,0,1,5.43.53Z",
    transform: "translate(-89.876 -177.684)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M200.225,419.235a44.441,44.441,0,0,1-5.449-.195,45.052,45.052,0,0,1-5.436-.53,44.567,44.567,0,0,1,5.479.195A44.875,44.875,0,0,1,200.225,419.235Z",
    transform: "translate(-90.021 -175.728)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M1.881,0H3.653A1.826,1.826,0,0,1,5.479,1.827V7.854H0V1.827A1.826,1.826,0,0,1,1.881,0Z",
    transform: "translate(164.148 274.047) rotate(-176.19)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M1.831,0H3.662A1.831,1.831,0,0,1,5.492,1.831V7.872H0V1.831A1.831,1.831,0,0,1,1.831,0Z",
    transform: "translate(159.09 260.102) rotate(4.004)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M1.889,0H3.668A1.834,1.834,0,0,1,5.5,1.835V7.887H0V1.835A1.834,1.834,0,0,1,1.889,0Z",
    transform: "translate(149.941 252.82) rotate(105.005)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M1.881,0H3.653A1.826,1.826,0,0,1,5.479,1.827V7.854H0V1.827A1.826,1.826,0,0,1,1.881,0Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 135.476, 254.081)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M1.876,0H3.643A1.821,1.821,0,0,1,5.464,1.822v6.01H0V1.822A1.821,1.821,0,0,1,1.876,0Z",
    transform: "translate(166.05 250.036) rotate(74.291)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M1.876,0H3.643A1.821,1.821,0,0,1,5.464,1.822V7.857H0V1.846A1.821,1.821,0,0,1,1.876,0Z",
    transform: "translate(150.491 259.219) rotate(-105.709)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M1.881,0H3.653A1.826,1.826,0,0,1,5.479,1.826V7.853H0V1.826A1.826,1.826,0,0,1,1.826,0Z",
    transform: "translate(154.256 274.332) rotate(-157.81)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M1.881,0H3.653A1.826,1.826,0,0,1,5.479,1.827V7.854H0V1.827A1.826,1.826,0,0,1,1.881,0Z",
    transform: "translate(154.728 258.519) rotate(22.19)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M411.5,75.885l4.115,5.236a.475.475,0,0,1-.079.657l-5.29,4.109a3.793,3.793,0,0,1-5.327-.664h0a3.8,3.8,0,0,1,.664-5.333l5.29-4.109a.475.475,0,0,1,.627.1Z",
    transform: "translate(-174.044 -41.622)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M418.608,78.925l-4.091-5.254a.469.469,0,0,1,.085-.657l5.284-4.109a3.793,3.793,0,0,1,5.327.664h0a3.8,3.8,0,0,1-.664,5.333L419.266,79a.469.469,0,0,1-.658-.073Z",
    transform: "translate(-178.076 -38.648)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M29.315,280.742l6.264,2.277a.475.475,0,0,1,.28.609l-2.289,6.289a3.8,3.8,0,0,1-4.87,2.277h0a3.8,3.8,0,0,1-2.277-4.87l2.289-6.289a.469.469,0,0,1,.6-.292Z",
    transform: "translate(-26.195 -121.826)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M36.667,278.963l-6.258-2.277a.463.463,0,0,1-.28-.609l2.289-6.295a3.793,3.793,0,0,1,4.87-2.271h0a3.793,3.793,0,0,1,2.271,4.87l-2.289,6.295a.475.475,0,0,1-.6.286Z",
    transform: "translate(-27.721 -116.57)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(5.345 277.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M295.558,478.838c0,.091-58.345.158-130.279.158S35,478.93,35,478.838s58.333-.158,130.309-.158S295.558,478.753,295.558,478.838Z",
    transform: "translate(-35 -478.68)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Medical_Prescription",
    "data-name": "Medical Prescription",
    transform: "translate(63.313 6.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 158.995,
    height: 209.999,
    rx: 10.1,
    transform: "translate(0 2.015)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 137.7,
    height: 185.648,
    transform: "translate(10.648 11.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M285.332,238.985c0-1.266-.061-75.726-.146-185.678l.146.14H147.644l.158-.158V238.966l-.134-.134,137.706.134-137.706.128h-.128v-.128c0-52.258,0-116.411-.03-185.678V53.13h138v.146C285.393,163.24,285.332,237.718,285.332,238.985Z",
    transform: "translate(-136.984 -41.393)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M188.5,93.514l-3.208-4.828h-3.549v4.828H177.89V76.188H185.1a8.967,8.967,0,0,1,3.847.767,5.753,5.753,0,0,1,2.508,2.161,6.137,6.137,0,0,1,.883,3.342,6.027,6.027,0,0,1-.895,3.354,5.668,5.668,0,0,1-2.526,2.131l3.738,5.57Zm-.974-13.277a3.921,3.921,0,0,0-2.642-.779h-3.141V85.5h3.141a3.9,3.9,0,0,0,2.642-.8A3.2,3.2,0,0,0,187.527,80.237Z",
    transform: "translate(-148.869 -50.413)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M201.619,113.773l-3.811-5.674-3.744,5.7H189.87l5.844-8.346-5.552-8.066h4.152l3.653,5.321,3.549-5.345h3.945l-5.479,7.914,5.887,8.486Z",
    transform: "translate(-153.556 -58.696)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 23.633,
    height: 5.85,
    transform: "translate(76.895 29.915)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M333.724,88.958c0,.091-6.465.158-14.44.158s-14.434-.067-14.434-.158,6.459-.158,14.434-.158S333.724,88.873,333.724,88.958Z",
    transform: "translate(-198.539 -55.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M314.279,100.484c0,.085-12.93.158-28.874.158s-28.874-.073-28.874-.158,12.924-.164,28.874-.164S314.279,100.393,314.279,100.484Z",
    transform: "translate(-179.635 -59.854)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M314.279,111.778c0,.085-12.93.158-28.874.158s-28.874-.073-28.874-.158,12.924-.158,28.874-.158S314.279,111.687,314.279,111.778Z",
    transform: "translate(-179.635 -64.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M283.733,141.894c0,.085-28.728.158-64.153.158s-64.159-.073-64.159-.158,28.716-.164,64.159-.164S283.733,141.791,283.733,141.894Z",
    transform: "translate(-140.079 -76.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M283.733,312.358c0,.085-28.728.158-64.153.158s-64.159-.073-64.159-.158,28.716-.158,64.159-.158S283.733,312.267,283.733,312.358Z",
    transform: "translate(-140.079 -142.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 39.589,
    height: 7.427,
    transform: "translate(25.91 76.329)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 17.137,
    height: 7.427,
    transform: "translate(25.91 180.205)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 17.137,
    height: 7.427,
    transform: "translate(83.452 180.205)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M232.747,338.208c0,.091-5.351.158-11.95.158s-11.956-.067-11.956-.158,5.351-.158,11.956-.158S232.747,338.123,232.747,338.208Z",
    transform: "translate(-160.978 -152.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M333.827,338.208c0,.091-5.351.158-11.95.158s-11.956-.067-11.956-.158,5.351-.158,11.956-.158S333.827,338.123,333.827,338.208Z",
    transform: "translate(-200.522 -152.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M279.57,189.7c0,.085-23.456.158-52.355.158s-52.355-.073-52.355-.158,23.444-.158,52.355-.158S279.57,189.607,279.57,189.7Z",
    transform: "translate(-147.684 -94.759)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M281.576,203.618c0,.091-23.907.158-53.39.158s-53.4-.067-53.4-.158,23.9-.158,53.4-.158S281.576,203.533,281.576,203.618Z",
    transform: "translate(-147.657 -100.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M225.768,217.548c0,.085-11.865.158-26.494.158s-26.494-.073-26.494-.158,11.859-.158,26.494-.158S225.768,217.457,225.768,217.548Z",
    transform: "translate(-146.87 -105.654)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M318.426,261.737s-.116.049-.353.122l-1.035.317a34.832,34.832,0,0,1-4.073.95,19.052,19.052,0,0,1-3.007.286,12.6,12.6,0,0,1-3.574-.444,9.132,9.132,0,0,1-3.61-2A6.922,6.922,0,0,1,300.6,256.9a4.779,4.779,0,0,1,.3-2.5,4.681,4.681,0,0,1,1.692-2.021,3.531,3.531,0,0,1,2.673-.566,3.6,3.6,0,0,1,1.291.609,3.933,3.933,0,0,1,.925,1.126,6.124,6.124,0,0,1,.651,2.873,8.205,8.205,0,0,1-.548,2.983,11.841,11.841,0,0,1-3.793,4.98,12.693,12.693,0,0,1-6.088,2.557,11.166,11.166,0,0,1-3.427-.043,11.5,11.5,0,0,1-1.7-.408,13.656,13.656,0,0,1-1.619-.718,9.891,9.891,0,0,1-2.746-2.265,7.574,7.574,0,0,1-1.625-3.245,5.29,5.29,0,0,1,.432-3.653,5.534,5.534,0,0,1,2.685-2.569,3.83,3.83,0,0,1,1.881-.329,3.653,3.653,0,0,1,1.772.67,5.394,5.394,0,0,1,1.93,3.129,10.21,10.21,0,0,1,.195,3.616,14.525,14.525,0,0,1-.785,3.464,13.155,13.155,0,0,1-3.823,5.7,10.428,10.428,0,0,1-6.088,2.49,8.773,8.773,0,0,1-9.363-6.459,8.334,8.334,0,0,1,.207-5.479,4.718,4.718,0,0,1,1.6-2.094,2.794,2.794,0,0,1,1.218-.505,1.948,1.948,0,0,1,1.254.237,2.7,2.7,0,0,1,1.218,2.058,6.571,6.571,0,0,1-.091,2.271,16.643,16.643,0,0,1-1.218,3.945,16.12,16.12,0,0,1-1.826,3.087,15.47,15.47,0,0,1-2.033,2.24,14.763,14.763,0,0,1-3.421,2.386,9.673,9.673,0,0,1-.986.457l-.347.134.335-.164c.219-.11.56-.243.974-.481a15.492,15.492,0,0,0,3.367-2.435,16.931,16.931,0,0,0,3.8-5.309,16.26,16.26,0,0,0,1.218-3.9,6.7,6.7,0,0,0,.079-2.21,2.514,2.514,0,0,0-1.108-1.893,1.723,1.723,0,0,0-1.114-.207,2.562,2.562,0,0,0-1.09.475,4.456,4.456,0,0,0-1.51,1.991,8.066,8.066,0,0,0-.177,5.321,8.523,8.523,0,0,0,9.083,6.246,10.16,10.16,0,0,0,5.9-2.435,12.815,12.815,0,0,0,3.726-5.576,14.489,14.489,0,0,0,.767-3.4,9.869,9.869,0,0,0-.195-3.507,5.022,5.022,0,0,0-1.826-2.94,3.312,3.312,0,0,0-3.342-.311,5.236,5.236,0,0,0-2.533,2.435,4.956,4.956,0,0,0-.4,3.427,8.383,8.383,0,0,0,4.213,5.309,13.754,13.754,0,0,0,1.565.694,11.165,11.165,0,0,0,4.986.444,12.584,12.584,0,0,0,3.16-.871,12.787,12.787,0,0,0,2.77-1.619,11.566,11.566,0,0,0,3.707-4.87,8,8,0,0,0,.542-2.88,5.9,5.9,0,0,0-.609-2.746,3.883,3.883,0,0,0-.852-1.053,3.33,3.33,0,0,0-1.187-.609,3.281,3.281,0,0,0-2.484.524,4.383,4.383,0,0,0-1.607,1.905,4.578,4.578,0,0,0-.3,2.38,6.745,6.745,0,0,0,2.094,3.939,8.98,8.98,0,0,0,3.525,1.979,12.412,12.412,0,0,0,3.519.463,19.074,19.074,0,0,0,2.989-.256,39.659,39.659,0,0,0,4.073-.889l1.047-.286Z",
    transform: "translate(-185.292 -119.1)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 45.951,
    height: 17.569,
    transform: "translate(56.519 0.231)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M268.936,51.651V46.933c0-3.044-.037-7.409-.061-12.845l.11.11-45.945.049h0l.158-.158V51.651l-.152-.152,32.874.073,9.576.043h3.476a1.254,1.254,0,0,1-.213,0h-3.19l-9.546.043-33,.067h-.152V34.008l.158-.158h0l45.945.049h.11v.11c0,5.479-.043,9.862-.061,12.912v4.359A.858.858,0,0,1,268.936,51.651Z",
    transform: "translate(-166.467 -33.85)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Medication",
    transform: "translate(184.162 190.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M367.791,425.388H338.033A2.435,2.435,0,0,1,335.6,423l-.718-80.255h34.591l.718,80.207A2.435,2.435,0,0,1,367.791,425.388Z",
    transform: "translate(-331.136 -338.492)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(32.278 22.048)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M381.75,371.992v61.785s4.87,1.619,5.108-2.642.11-59.155.11-59.155Z",
    transform: "translate(-381.75 -371.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M367.17,336.05h-28a1.826,1.826,0,0,0-1.826,1.826v1.8H369v-1.826a1.826,1.826,0,0,0-1.826-1.8Z",
    transform: "translate(-332.098 -335.875)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M367.048,335.938a1.049,1.049,0,0,1,.3,0,1.735,1.735,0,0,1,.828.335,1.857,1.857,0,0,1,.737,1.254v2.07h-.079c-5.8.043-17.009.079-29.83.079h-1.979v-1.857a2,2,0,0,1,.712-1.6,1.979,1.979,0,0,1,.8-.4,3.778,3.778,0,0,1,.852-.055h7.774l10.349.037,6.958.049h0l-6.958.049-10.349.036h-7.774a3.216,3.216,0,0,0-.779.049,1.734,1.734,0,0,0-.67.335c-.877.664-.524,1.942-.609,3.044l-.158-.158H339c12.839,0,24.047.03,29.83.079l-.079.079v-1.979a1.778,1.778,0,0,0-.664-1.218A2.07,2.07,0,0,0,367.048,335.938Z",
    transform: "translate(-331.977 -335.763)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 41.878,
    height: 19.122,
    rx: 2.64,
    transform: "translate(0.122 2.921)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M369.116,359.484a1.4,1.4,0,0,0,.3-.049,1.559,1.559,0,0,0,.773-.414c.712-.536.426-1.826.469-3.306,0-3.044-.03-7.4-.049-12.784v-1.023a1.473,1.473,0,0,0-.335-.889,1.552,1.552,0,0,0-.834-.511,6.692,6.692,0,0,0-1.059-.03H330.465a1.443,1.443,0,0,0-1.187.609,1.4,1.4,0,0,0-.25.609,7.3,7.3,0,0,0,0,.743V357.8a1.479,1.479,0,0,0,.134.609,1.455,1.455,0,0,0,.913.791,1.826,1.826,0,0,0,.639.061h2.021l18.951.03,12.784.055h3.47l-3.47.03-12.784.049-18.951.037h-2.021a2.107,2.107,0,0,1-.718-.073,1.76,1.76,0,0,1-1.108-.95,1.827,1.827,0,0,1-.158-.737V341.537a1.827,1.827,0,0,1,.311-.779,1.759,1.759,0,0,1,1.443-.743H368.4a6.29,6.29,0,0,1,1.114.043,1.826,1.826,0,0,1,.962.609,1.759,1.759,0,0,1,.384,1.035v1.029c0,5.382-.043,9.741-.055,12.784v2a1.668,1.668,0,0,1-.536,1.352,1.534,1.534,0,0,1-.81.4A1,1,0,0,1,369.116,359.484Z",
    transform: "translate(-328.73 -337.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M332.818,359.774c-.091,0-.158-4.073-.158-9.089s.067-9.1.158-9.1.158,4.073.158,9.1S332.9,359.774,332.818,359.774Z",
    transform: "translate(-330.268 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M338.018,359.774c-.091,0-.158-4.073-.158-9.089s.067-9.1.158-9.1.158,4.073.158,9.1S338.1,359.774,338.018,359.774Z",
    transform: "translate(-332.302 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M343.218,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S343.3,359.774,343.218,359.774Z",
    transform: "translate(-334.336 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M348.418,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S348.51,359.774,348.418,359.774Z",
    transform: "translate(-336.371 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M353.628,359.774c-.091,0-.158-4.073-.158-9.089s.067-9.1.158-9.1.158,4.073.158,9.1S353.714,359.774,353.628,359.774Z",
    transform: "translate(-338.409 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M358.828,359.774c-.091,0-.158-4.073-.158-9.089s.067-9.1.158-9.1.158,4.073.158,9.1S358.914,359.774,358.828,359.774Z",
    transform: "translate(-340.443 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M364.028,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S364.114,359.774,364.028,359.774Z",
    transform: "translate(-342.477 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M369.228,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S369.32,359.774,369.228,359.774Z",
    transform: "translate(-344.512 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M374.428,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.164,4.073.164,9.1S374.52,359.774,374.428,359.774Z",
    transform: "translate(-346.546 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M379.638,359.774c-.091,0-.158-4.073-.158-9.089s.067-9.1.158-9.1.158,4.073.158,9.1S379.724,359.774,379.638,359.774Z",
    transform: "translate(-348.584 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M384.838,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S384.924,359.774,384.838,359.774Z",
    transform: "translate(-350.619 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M390.038,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S390.13,359.774,390.038,359.774Z",
    transform: "translate(-352.653 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M395.238,359.774c-.085,0-.158-4.073-.158-9.089s.073-9.1.158-9.1.158,4.073.158,9.1S395.33,359.774,395.238,359.774Z",
    transform: "translate(-354.687 -338.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 29.946,
    height: 23.98,
    transform: "translate(6.471 36.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M346.319,405.856l-.7-1.011h-.767v1.011H344V402.24h1.565a1.929,1.929,0,0,1,.828.164,1.217,1.217,0,0,1,.548.451,1.254,1.254,0,0,1,.189.7,1.177,1.177,0,0,1-.743,1.138l.81,1.163Zm-.213-2.77a.877.877,0,0,0-.572-.164h-.682v1.26h.682a.877.877,0,0,0,.572-.164.651.651,0,0,0,0-.931Z",
    transform: "translate(-334.704 -361.769)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M349.175,410.081l-.828-1.187-.81,1.187h-.907l1.266-1.741-1.218-1.68h.9l.785,1.108.773-1.108H350l-1.218,1.65,1.272,1.772Z",
    transform: "translate(-335.733 -363.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 17.101,
    height: 2.599,
    transform: "translate(17.125 40.458)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M367.416,417c0,.085-4.992.158-11.153.158s-11.153-.073-11.153-.158,4.992-.158,11.153-.158S367.416,416.937,367.416,417Z",
    transform: "translate(-335.138 -367.482)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M367.416,421.438c0,.091-4.992.158-11.153.158s-11.153-.067-11.153-.158,4.992-.158,11.153-.158S367.416,421.353,367.416,421.438Z",
    transform: "translate(-335.138 -369.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 11.555,
    height: 2.228,
    transform: "translate(8.365 55.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M368.9,419.067v-1.644c0-1.078,0-2.63-.03-4.608,0-3.969-.043-9.619-.067-16.437l.128.134h-28.7c-.037.03.3-.3.158-.152h0v22.683l-.14-.14,20.7.073,5.881.037h.061l-5.85.036-20.8.073h-.14V396.293h0c-.14.134.195-.2.158-.164h28.838v.134c0,6.849-.055,12.535-.067,16.522,0,1.96-.03,3.507-.036,4.578v1.218A1.141,1.141,0,0,1,368.9,419.067Z",
    transform: "translate(-333.164 -359.378)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M338.018,431.82c-.091,0-.158-12.517-.158-27.955s.067-27.955.158-27.955.158,12.517.158,27.955S338.1,431.82,338.018,431.82Z",
    transform: "translate(-332.302 -351.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M369.821,476.258c0,.085-6.532.158-14.611.158s-14.611-.073-14.611-.158,6.532-.158,14.611-.158S369.821,476.173,369.821,476.258Z",
    transform: "translate(-333.374 -390.665)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M420.207,435.414H396.1a1.96,1.96,0,0,1-1.96-1.942l-.609-65.012h28l.578,64.975a1.954,1.954,0,0,1-1.906,1.978Z",
    transform: "translate(-354.081 -348.554)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(62.577 34.321)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M431.52,392.14v50.066s3.945,1.309,4.14-2.143.085-47.923.085-47.923Z",
    transform: "translate(-431.52 -392.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M419.346,363h-22.02a1.826,1.826,0,0,0-1.826,1.826v1.09h25.654v-1.09A1.826,1.826,0,0,0,419.346,363Z",
    transform: "translate(-354.852 -346.418)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M419.244,362.937a.954.954,0,0,1,.262,0,1.637,1.637,0,0,1,.731.244,1.881,1.881,0,0,1,.791.968,2.282,2.282,0,0,1,.11.8v1.035h-.079c-4.742.049-13.649.079-23.834.079H395.24v-1.528a1.979,1.979,0,0,1,2-1.692h6.191l8.243.03,5.522.049,1.5.03a3.4,3.4,0,0,1,.517.03,3.4,3.4,0,0,1-.517,0l-1.5.03-5.522.049-8.243.037h-6.161a1.674,1.674,0,0,0-1.108.383,1.619,1.619,0,0,0-.578,1.041c-.036.4,0,.883,0,1.327l-.158-.158h1.826c10.185,0,19.091.03,23.834.079l-.079.079v-.9a2,2,0,0,0-.085-.755,1.772,1.772,0,0,0-.712-.938A2.186,2.186,0,0,0,419.244,362.937Z",
    transform: "translate(-354.75 -346.355)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 33.927,
    height: 15.493,
    rx: 2.64,
    transform: "translate(36.527 18.828)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M420.958,382.084a1.826,1.826,0,0,0,.9-.317,1.6,1.6,0,0,0,.609-.938,3.234,3.234,0,0,0,.03-.743c0-.268,0-.56,0-.858,0-2.435-.03-5.96-.049-10.294v-.822a1.461,1.461,0,0,0-.25-.731,1.51,1.51,0,0,0-1.394-.664H390.251a1.455,1.455,0,0,0-1.449,1.4v11.81a2.782,2.782,0,0,0,.1,1.053,1.522,1.522,0,0,0,.651.743,1.826,1.826,0,0,0,.992.183h1.084l15.268.036,10.294.049H420l-2.8.03-10.294.049-15.268.037h-1.084a2.112,2.112,0,0,1-1.132-.11,1.758,1.758,0,0,1-.907-1.5V368.143a1.772,1.772,0,0,1,1.765-1.7H420.83a1.826,1.826,0,0,1,1.6.785,1.7,1.7,0,0,1,.274.846v.834c0,4.335-.043,7.847-.055,10.294v.858a3.435,3.435,0,0,1-.049.761,1.626,1.626,0,0,1-.676.974,1.528,1.528,0,0,1-.688.256A.78.78,0,0,1,420.958,382.084Z",
    transform: "translate(-352.117 -347.763)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M391.9,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S391.959,382.256,391.9,382.256Z",
    transform: "translate(-353.381 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M396.068,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S396.16,382.256,396.068,382.256Z",
    transform: "translate(-355.012 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M400.288,382.256c-.091,0-.158-3.293-.158-7.36s.067-7.366.158-7.366.158,3.294.158,7.366S400.374,382.256,400.288,382.256Z",
    transform: "translate(-356.663 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M404.5,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S404.59,382.256,404.5,382.256Z",
    transform: "translate(-358.31 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M408.718,382.256c-.091,0-.158-3.293-.158-7.36s.067-7.366.158-7.366.158,3.294.158,7.366S408.828,382.256,408.718,382.256Z",
    transform: "translate(-359.961 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M412.9,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S413.008,382.256,412.9,382.256Z",
    transform: "translate(-361.596 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M417.148,382.256c-.091,0-.158-3.293-.158-7.36s.067-7.366.158-7.366.158,3.294.158,7.366S417.234,382.256,417.148,382.256Z",
    transform: "translate(-363.259 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M421.358,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S421.443,382.256,421.358,382.256Z",
    transform: "translate(-364.906 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M425.574,382.256c-.091,0-.164-3.293-.164-7.36s.073-7.366.164-7.366.158,3.294.158,7.366S425.66,382.256,425.574,382.256Z",
    transform: "translate(-366.553 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M429.788,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S429.855,382.256,429.788,382.256Z",
    transform: "translate(-368.204 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M434,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S434.09,382.256,434,382.256Z",
    transform: "translate(-369.851 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M438.218,382.256c-.091,0-.158-3.293-.158-7.36s.067-7.366.158-7.366.158,3.294.158,7.366S438.3,382.256,438.218,382.256Z",
    transform: "translate(-371.502 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M442.428,382.256c-.085,0-.158-3.293-.158-7.36s.073-7.366.158-7.366.158,3.294.158,7.366S442.52,382.256,442.428,382.256Z",
    transform: "translate(-373.149 -348.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 24.26,
    height: 19.426,
    transform: "translate(41.671 45.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M402.826,419.588l-.56-.816h-.609v.816H401V416.66h1.218a1.631,1.631,0,0,1,.676.128.98.98,0,0,1,.438.371,1.084,1.084,0,0,1,0,1.126.974.974,0,0,1-.444.359l.657.944Zm-.17-2.246a.725.725,0,0,0-.463-.128h-.554v1.017h.578a.688.688,0,0,0,.463-.134.45.45,0,0,0,.158-.377.457.457,0,0,0-.171-.378Z",
    transform: "translate(-357.003 -367.411)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M405.134,423.01l-.67-.962-.657.962h-.737l1.023-1.412-.974-1.358h.731l.609.895.609-.895h.694l-.907,1.333,1.029,1.437Z",
    transform: "translate(-357.813 -368.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 13.85,
    height: 2.106,
    transform: "translate(50.297 49.237)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M419.909,428.588c0,.091-4.042.158-9.034.158s-9.034-.067-9.034-.158,4.042-.158,9.034-.158S419.909,428.5,419.909,428.588Z",
    transform: "translate(-357.332 -372.016)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M419.909,432.2c0,.085-4.042.158-9.034.158s-9.034-.073-9.034-.158,4.042-.158,9.034-.158S419.909,432.107,419.909,432.2Z",
    transform: "translate(-357.332 -373.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 9.363,
    height: 1.802,
    transform: "translate(43.205 61.51)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M421.11,430.247v-1.339c0-.883,0-2.143-.03-3.738,0-3.22-.043-7.792-.067-13.308l.128.134H397.891l.158-.158h0v18.355l-.14-.146,16.76.073,4.773.037h.085l-4.742.037-16.851.073h-.146V411.746h0c-.14.14.195-.195.164-.158h23.383v.25c0,5.546-.055,10.154-.067,13.393,0,1.583-.03,2.831-.036,3.7v.968A2.187,2.187,0,0,1,421.11,430.247Z",
    transform: "translate(-355.733 -365.426)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M396.068,440.623c-.085,0-.158-10.142-.158-22.647s.073-22.647.158-22.647.158,10.136.158,22.647S396.16,440.623,396.068,440.623Z",
    transform: "translate(-355.012 -359.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M421.879,476.6c0,.091-5.3.158-11.823.158s-11.816-.067-11.816-.158,5.29-.158,11.816-.158S421.879,476.513,421.879,476.6Z",
    transform: "translate(-355.924 -390.798)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(22.935 39.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M105.061,433.441l-4.036,14.337s12.864,9.022,12.37,11.743L86,452.478l5.4-22.6Z",
    transform: "translate(-72.542 -221.52)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M96.54,453.7a1.169,1.169,0,0,0-1.09,1.114,1.126,1.126,0,0,0,1.065,1.12,1.218,1.218,0,0,0,1.151-1.181c-.055-.578-.682-1.181-1.218-1.041",
    transform: "translate(-76.239 -230.838)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(13.458 228.705)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M86,465.552l.609-2.252,26.044,7.579s1.09.852.737,1.7Z",
    transform: "translate(-86 -463.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M109.62,459.042c-.043.14-.724,0-1.492.3s-1.26.761-1.37.676.286-.828,1.218-1.138S109.675,458.9,109.62,459.042Z",
    transform: "translate(-80.656 -232.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M114.239,462.368c0,.146-.609.225-1.218.694s-.877,1.041-1.011,1,0-.834.724-1.394S114.269,462.24,114.239,462.368Z",
    transform: "translate(-82.7 -234.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M116.952,467.562c-.128,0-.146-.731.377-1.394s1.218-.8,1.254-.676-.457.432-.883.986S117.067,467.611,116.952,467.562Z",
    transform: "translate(-84.621 -235.436)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M110.544,453.112c-.091.11-.657-.237-1.425-.377s-1.418-.049-1.461-.189.645-.475,1.546-.3S110.636,453.021,110.544,453.112Z",
    transform: "translate(-81.015 -230.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M92.442,441.182l-.609,14.9s14.611,5.668,14.72,8.438L78.3,464.3l.061-23.268Z",
    transform: "translate(-69.53 -225.883)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M85.617,463.578a1.181,1.181,0,0,0-.81,1.339,1.1,1.1,0,0,0,1.291.834,1.248,1.248,0,0,0,.852-1.425,1.138,1.138,0,0,0-1.425-.712",
    transform: "translate(-72.068 -234.697)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(8.74 236.071)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M78.25,477.744l.1-2.344,27.054,1.09s1.254.572,1.1,1.479Z",
    transform: "translate(-78.25 -475.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M99.575,465.444c0,.14-.694.2-1.382.645s-1.047,1.041-1.175.986.085-.871.925-1.4S99.605,465.31,99.575,465.444Z",
    transform: "translate(-76.839 -235.381)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M104.876,467.594c0,.134-.566.371-1.041.968s-.609,1.218-.749,1.218-.219-.81.384-1.534S104.876,467.46,104.876,467.594Z",
    transform: "translate(-79.188 -236.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M108.706,472.058c-.128.03-.31-.676.049-1.449s1-1.078,1.065-.956-.347.53-.609,1.163S108.822,472.046,108.706,472.058Z",
    transform: "translate(-81.362 -237.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M98.985,459.6c-.055.128-.688-.073-1.467,0s-1.394.3-1.461.177.517-.609,1.437-.67S99.064,459.49,98.985,459.6Z",
    transform: "translate(-76.474 -232.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M72.6,262.11V273.9l3.087,45.914s-1.924,22.275-3.1,34.853c-1.023,10.915.651,29.934.651,29.934H91.212l6.453-63.417,3.994-39.571,6.964-17.983Z",
    transform: "translate(-67.161 -155.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M103.061,242.858l-3.446,64.056-18.2,47.966-.834,2.892L69.84,355.1,77.833,241.61Z",
    transform: "translate(-50.264 -134.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M113.794,294.94a1.826,1.826,0,0,1,0,.268c0,.195,0,.45,0,.779,0,.706-.049,1.717-.091,3.007-.073,2.606-.256,6.374-.511,11.031-.542,9.314-1.552,22.166-3.135,36.314s-3.269,26.92-4.523,36.162c-.609,4.6-1.151,8.334-1.51,10.958-.183,1.278-.329,2.277-.426,2.971-.055.329-.091.609-.122.773a1.455,1.455,0,0,1-.055.262V397.2c0-.189.055-.444.091-.773.085-.7.207-1.7.365-2.983.329-2.6.81-6.337,1.406-10.958,1.218-9.247,2.867-22.02,4.426-36.168s2.624-26.975,3.227-36.283c.286-4.651.505-8.419.609-11.025.067-1.291.116-2.3.152-3,0-.329.037-.609.049-.779a1.332,1.332,0,0,1,.049-.286Z",
    transform: "translate(-79.357 -168.729)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M121.141,268.01a.931.931,0,1,1-.264-.668.925.925,0,0,1,.264.668Z",
    transform: "translate(-85.566 -157.822)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M145.246,276.384a6.087,6.087,0,0,1-1.266-1.218,14.678,14.678,0,0,1-2.265-3.653,14.945,14.945,0,0,1-1.132-4.146,6.033,6.033,0,0,1-.043-1.778c.055,0,.091.676.274,1.747a17.922,17.922,0,0,0,1.218,4.036,17.653,17.653,0,0,0,2.137,3.61C144.814,275.86,145.283,276.341,145.246,276.384Z",
    transform: "translate(-93.861 -157.247)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M144.77,167.18s3.44,1.351,5.035,6.392c1.108,3.507,6.295,29.611,6.295,29.611l-7.232,4.767-2.94-24.443Z",
    transform: "translate(-95.534 -118.747)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M88.354,146.7l-2.265,4.018s-15.14,7.695-15.086,8.45c0,0,.846,28.722,1,49.792.061,7.957-.231,15.268-.39,18.781-.42,9.223-.749,45.05-.749,45.05l54.79-1.3-9.8-112.326-7.732-3.379-.986-2.015-3.549-2.886Z",
    transform: "translate(-66.623 -110.735)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M135.46,291.482a1.218,1.218,0,0,0,0-.243,6.612,6.612,0,0,0-.03-.712c-.037-.651-.085-1.577-.152-2.758-.14-2.4-.347-5.863-.609-10.118-.517-8.559-1.218-20.358-2.015-33.392s-1.431-24.832-1.924-33.4c-.225-4.261-.414-7.713-.542-10.124-.067-1.181-.116-2.1-.152-2.752,0-.3-.037-.536-.049-.712a1.825,1.825,0,0,0-.03-.243,1.448,1.448,0,0,0,0,.243v.718c0,.645.049,1.571.091,2.752.085,2.393.237,5.856.438,10.13.4,8.523,1.047,20.364,1.826,33.41s1.534,24.838,2.112,33.379c.292,4.261.536,7.707.7,10.118.091,1.175.164,2.1.213,2.746l.061.718A1.094,1.094,0,0,0,135.46,291.482Z",
    transform: "translate(-89.737 -130.425)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M88.782,130.559l1.272,8.791L92.337,157l-9.923-17.028L73.8,128.69l14.191,9.947.183-8.249",
    transform: "translate(-51.813 -90.405)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M95.76,154.18a3.878,3.878,0,0,0,.274.688c.213.481.493,1.12.846,1.905l3.08,6.7.037.085h2.167l-.1-.28-1.522,1.248-.14.116.128.128,2.886,2.825,9.284,9,2.837,2.7.785.724a1.588,1.588,0,0,0,.286.237,1.309,1.309,0,0,0-.244-.286l-.737-.767-2.77-2.776-9.211-9.071c-.992-.974-1.966-1.918-2.892-2.819v.237l1.516-1.254.335-.28H100.1l.134.085c-1.3-2.7-2.393-4.992-3.19-6.648-.384-.773-.688-1.4-.919-1.869A4.632,4.632,0,0,0,95.76,154.18Z",
    transform: "translate(-76.36 -113.661)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M129.761,181.844a7.349,7.349,0,0,0,.2-1.1c.11-.761.25-1.772.42-3,.341-2.533.791-6.033,1.266-9.9l.438-3.6v-.14l-.14-.037-2.49-.609v.292l2.5-.444.17-.03-.073-.152-1.644-3.574c-.189-.384-.341-.706-.469-.968a1.218,1.218,0,0,0-.189-.329,1.522,1.522,0,0,0,.122.359c.11.268.243.609.4,1,.39.913.913,2.137,1.54,3.616l.1-.177-2.5.408-.718.116.706.177,2.484.609-.122-.17c-.146,1.145-.292,2.356-.451,3.6-.475,3.872-.889,7.372-1.169,9.911-.128,1.218-.237,2.246-.317,3.044A7.068,7.068,0,0,0,129.761,181.844Z",
    transform: "translate(-89.243 -115.257)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M103.641,274.194h-.353l-1.053.067-4.042.292-14.477,1.114H83.57v.146c.231,2.721.487,5.68.755,8.8q.2,2.35.414,4.8c.073.822.14,1.644.213,2.478a6.7,6.7,0,0,0,.2,1.278,4.487,4.487,0,0,0,.572,1.218,5.217,5.217,0,0,0,3.4,2.052,27.732,27.732,0,0,0,3.86.207,32.688,32.688,0,0,0,7.238-.791,10.894,10.894,0,0,0,1.65-.542,5.053,5.053,0,0,0,.767-.39,2.5,2.5,0,0,0,.347-.28,3.538,3.538,0,0,0,.274-.341,8.079,8.079,0,0,0,.944-3.087,37.956,37.956,0,0,0,.286-5.729c-.055-3.507-.3-6.331-.493-8.279-.091-.974-.183-1.723-.25-2.234a4.674,4.674,0,0,0-.079-.609.609.609,0,0,0-.043-.195v.2a3.2,3.2,0,0,0,.049.609c.049.536.11,1.285.189,2.24.152,1.948.365,4.773.39,8.267a40.014,40.014,0,0,1-.323,5.686,7.914,7.914,0,0,1-.919,2.965,2.478,2.478,0,0,1-1.266.9,10.471,10.471,0,0,1-1.6.517,32.688,32.688,0,0,1-7.165.767,27.458,27.458,0,0,1-3.8-.207,4.907,4.907,0,0,1-3.2-1.918,4.419,4.419,0,0,1-.524-1.1,6.612,6.612,0,0,1-.189-1.218c-.073-.834-.146-1.662-.213-2.484-.146-1.632-.286-3.239-.426-4.8-.28-3.123-.542-6.088-.785-8.8l-.128.158L98.1,274.712l4.067-.371,1.084-.1A2.837,2.837,0,0,0,103.641,274.194Z",
    transform: "translate(-71.591 -160.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(13.592 132.177)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M86.22,304.74c1.546,4.03,5.583,4.261,9.929,3.653,4.085-.609,8.018-1.455,8.322-2.624a5.567,5.567,0,0,1-3.653,4.633,14.2,14.2,0,0,1-6.289.883c-2.234-.1-4.164,0-6.009-1.272A6.093,6.093,0,0,1,86.22,304.74Z",
    transform: "translate(-86.22 -304.74)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M151.1,238.679a.719.719,0,0,1,0-.152l-.055-.438q-.061-.609-.183-1.7c-.146-1.51-.353-3.653-.609-6.258-.5-5.284-1.169-12.59-1.875-20.656s-1.315-15.378-1.723-20.7c-.2-2.648-.347-4.791-.432-6.27-.049-.743-.067-1.315-.079-1.711v-.444a.438.438,0,0,1,0-.152c.146,1.717,1.163,13.351,2.551,29.221.694,8.06,1.327,15.353,1.784,20.668.213,2.624.39,4.755.511,6.264.055.718.1,1.291.128,1.7v.444a.609.609,0,0,1-.018.177Z",
    transform: "translate(-96.07 -123.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M160.656,225.885a7.61,7.61,0,0,1,.256,2.593c-.128,1.333-.189,4.608-3.738,5.729s-5.272.049-6.362-1.455l-.542-6.514,3.8-2.508Z",
    transform: "translate(-97.686 -140.87)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(5.745 89.203)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2834",
    "data-name": "Path 2834",
    d: "M100.9,234.15s-9.077,8.967-16.127,10.258-9.57-1.218-11.445-7.531Z",
    transform: "translate(-73.33 -234.15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2835",
    "data-name": "Path 2835",
    d: "M68.522,166.82s-5.765,5.345-4.121,18c1.522,11.762,4.261,28.138,7.841,30.043s11.4.95,17.107-2.283,22.233-11.975,22.233-11.975l-6.843-12.176-22.044,8.523s-2.849-19.481-4.56-22.866",
    transform: "translate(-63.976 -118.606)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2836",
    "data-name": "Path 2836",
    d: "M77.96,174s.061.128.17.377c.049.122.122.274.195.463s.134.42.219.67c.323,1.011.706,2.526,1.126,4.5.852,3.939,1.881,9.686,2.965,16.845l-.158-.1,22.032-8.584.122-.049.067.116c2.161,3.847,4.462,7.914,6.849,12.176l.079.146-.146.079L97.344,208.26l-6.934,3.732c-1.138.609-2.271,1.248-3.446,1.753a28.716,28.716,0,0,1-3.6,1.248,23.564,23.564,0,0,1-7.354.852,10.769,10.769,0,0,1-3.525-.761l-.414-.183c-.134-.067-.262-.164-.4-.25a4.006,4.006,0,0,1-.609-.645,8.433,8.433,0,0,1-.931-1.5,33.806,33.806,0,0,1-2.216-6.38c-.554-2.112-.992-4.188-1.388-6.2-.779-4.024-1.358-7.8-1.826-11.25a54.7,54.7,0,0,1-.785-9.375,23.359,23.359,0,0,1,1.254-6.983,15.487,15.487,0,0,1,2.088-3.969,9.244,9.244,0,0,1,.755-.895,3.557,3.557,0,0,1,.292-.268l-.268.292a10.53,10.53,0,0,0-.724.907,15.908,15.908,0,0,0-2.021,3.975,23.34,23.34,0,0,0-1.218,6.946,53.5,53.5,0,0,0,.828,9.333c.5,3.446,1.09,7.22,1.881,11.238.4,2,.84,4.073,1.4,6.179a33.72,33.72,0,0,0,2.2,6.319,8.558,8.558,0,0,0,.883,1.443,3.91,3.91,0,0,0,.609.609,2.858,2.858,0,0,0,.353.213l.39.177a10.471,10.471,0,0,0,3.434.712,23.335,23.335,0,0,0,7.251-.846,29.27,29.27,0,0,0,3.555-1.218c1.169-.505,2.277-1.132,3.421-1.741l6.934-3.738,14.142-7.61-.067.219-6.831-12.176.189.067L82.587,197l-.14.055v-.146c-1.053-7.153-2.046-12.906-2.855-16.851-.4-1.972-.761-3.494-1.065-4.5-.073-.25-.14-.475-.2-.67l-.177-.469C78.027,174.138,77.96,174,77.96,174Z",
    transform: "translate(-63.893 -118.747)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 10.94,
    height: 3.641,
    transform: "translate(32.921 69.844) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M103.72,198.881a17.783,17.783,0,0,1,3.409-.164,17.825,17.825,0,0,1,3.415.164,18.786,18.786,0,0,1-3.415.158,18.746,18.746,0,0,1-3.409-.158Z",
    transform: "translate(-79.474 -131.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(20.52 43.112)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M90.834,159.869l-16.1-13.058.384-1.145H73.716L71.39,136.62l3.348,6.569,1.942-.091-1.406,1.291Z",
    transform: "translate(-71.39 -136.62)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M94.8,164.53l.609-.243c0-.03-1.321-3.178-2.618-6.514a6.441,6.441,0,0,1-.548-3.275,1.528,1.528,0,0,1,1.546-1.218l.426-.225.219-.39a2.6,2.6,0,0,0-2.819,1.741,7.068,7.068,0,0,0,.609,3.616C93.476,161.377,94.785,164.5,94.8,164.53Z",
    transform: "translate(-74.728 -113.053)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M94.461,179.094l.81-.317c-.664-1.711-1.571-4.736-1.181-5.589a2.539,2.539,0,0,1,1.741-1.151,2.91,2.91,0,0,1,2.539.524c.925.785,2.326,3.549,2.788,4.554l.785-.365c-.067-.152-1.747-3.787-3.013-4.87a3.762,3.762,0,0,0-3.287-.706,3.306,3.306,0,0,0-2.338,1.674C92.647,174.26,94.15,178.327,94.461,179.094Z",
    transform: "translate(-75.335 -120.263)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M104.115,197.161a4.017,4.017,0,0,0,2.928-1.595l-.329-.292c-1.035,1.175-2.106,1.638-3.166,1.388-4.328-1.017-7.628-13.04-7.658-13.162l-.42.11c.14.505,3.4,12.4,7.975,13.472A2.8,2.8,0,0,0,104.115,197.161Z",
    transform: "translate(-76.247 -125.132)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M113.009,202.975h0a.517.517,0,0,0,.676.049l.938-.7a.609.609,0,0,0,.177-.864h0a.609.609,0,0,0-.956-.091l-.846.877A.517.517,0,0,0,113.009,202.975Z",
    transform: "translate(-83.047 -132.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M106.087,196.4a3.391,3.391,0,0,0,2.953-1.321c2.66-3.732-2.356-14.093-2.569-14.532l-.39.189c.049.11,5.12,10.568,2.606,14.093-.657.919-1.826,1.285-3.421,1.084l-.055.426A6.375,6.375,0,0,0,106.087,196.4Z",
    transform: "translate(-80.057 -123.978)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M105.269,205.776h0a.517.517,0,0,1-.475.481l-1.169.1a.609.609,0,0,1-.7-.53h0a.609.609,0,0,1,.651-.706l1.218.1A.524.524,0,0,1,105.269,205.776Z",
    transform: "translate(-79.16 -133.589)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 3.093,
    cy: 3.093,
    r: 3.093,
    transform: "translate(43.848 53.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 3.093,
    cy: 3.093,
    r: 3.093,
    transform: "translate(43.848 53.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M137.25,178.773a2.289,2.289,0,1,0,2.283-2.283A2.289,2.289,0,0,0,137.25,178.773Z",
    transform: "translate(-92.592 -122.389)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M128.252,156.111c.292.42,3.525,7.244,5.29,10.684l.517-.268c-.262-.505-4.962-10.2-5.327-10.745L125.312,153l-.122.651Z",
    transform: "translate(-87.874 -113.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M127.9,179.025c2.24,2.234,7.914,8.048,7.914,8.048l1.516-.913-7.987-8.523a1,1,0,0,0-1.285-.146h0a1,1,0,0,0-.158,1.534Z",
    transform: "translate(-88.823 -122.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M130.74,197.137l1.905-5.369a3.044,3.044,0,0,1,2.746-2.058h.286c1.145.128,6.971.511,6.971.511l2.252,2.526a1.151,1.151,0,0,1,0,1.522h0l.651,4.566-1.26.877.128,3.19s-1.138.755-1.644.505l-.511-.256-.755-.761-2.155,3.044-2.977,1.723Z",
    transform: "translate(-90.045 -127.561)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M149.15,196.129a10.349,10.349,0,0,0-.816-.883,3.842,3.842,0,0,0-1.09-.657,8.165,8.165,0,0,0-1.577-.213,26.623,26.623,0,0,1-4.158-.56,26.6,26.6,0,0,1,4.188.231,6.921,6.921,0,0,1,1.65.256,3.653,3.653,0,0,1,1.145.767A1.936,1.936,0,0,1,149.15,196.129Z",
    transform: "translate(-94.259 -129.164)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M149.363,202.062a9.438,9.438,0,0,0-.469-1.163,4.523,4.523,0,0,0-2.253-1.887,8.558,8.558,0,0,0-2.983-.505,6.632,6.632,0,0,1-1.278-.037,3.8,3.8,0,0,1,1.278-.195,7.39,7.39,0,0,1,3.1.426,4.383,4.383,0,0,1,2.338,2.088A1.973,1.973,0,0,1,149.363,202.062Z",
    transform: "translate(-94.599 -130.904)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M148.982,208.239a2.472,2.472,0,0,1-.3-1.254,4.2,4.2,0,0,0-.286-1.309,1.607,1.607,0,0,0-1.218-.907,22.647,22.647,0,0,0-3.044-.438,3.464,3.464,0,0,1-1.26-.292,9.06,9.06,0,0,1,1.285.061,15.1,15.1,0,0,1,3.1.347,2.478,2.478,0,0,1,.852.4,1.717,1.717,0,0,1,.536.712,3.873,3.873,0,0,1,.237,1.412C148.909,207.758,149.037,208.221,148.982,208.239Z",
    transform: "translate(-94.791 -133.166)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M115.77,172.57,90.64,198.522l.968.98,18-2.027L133.839,174.4l-.03-1.114Z",
    transform: "translate(-58.401 -107.572)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(51.059 75.607)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M158.781,213.317a5.741,5.741,0,0,0-4.414-1.473,8.09,8.09,0,0,0-4.347,1.826,5.856,5.856,0,0,0-2.167,3.1c-.511,2.179,1.285,5.229,3.263,6.289h0c2.508-2.015,4.949-5.108,7.458-7.117a2.161,2.161,0,0,0,.871-1.114A1.772,1.772,0,0,0,158.781,213.317Z",
    transform: "translate(-147.765 -211.817)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M160.556,196.968a2.345,2.345,0,0,1-.329,0h-.962l-3.6-.043-12.541-.219.116-.049-6.295,6.532-13.058,13.436-3.981,4.042-1.1,1.09a4.062,4.062,0,0,1-.4.365,2.849,2.849,0,0,1,.359-.39l1.053-1.132,3.908-4.115c3.342-3.476,7.914-8.243,12.985-13.5,2.222-2.3,4.359-4.5,6.307-6.514l.049-.049h.049l12.523.359,3.6.128.962.049a1.608,1.608,0,0,1,.353.012Z",
    transform: "translate(-85.221 -130.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M157.786,209.82a12.109,12.109,0,0,1,3.233.444A21.608,21.608,0,0,1,164,212.973s0,1.583-.609,1.644a5.532,5.532,0,0,1,.128,1.078,1.781,1.781,0,0,1-1.017,2.155s.128,1.455-.317,1.826a8.653,8.653,0,0,1-.95.694s-.067,1.6-2.216,1.583l-2.015.889s-4.481-.42-4.006-.95a21.016,21.016,0,0,0,1.552-3.153s-3.044-2.234-3.007-2.928.317-.761.317-.761-.122-1.327.95-1.455c0,0,.828-1.65,1.65-1.711s6.4,1.96,6.4,1.96l-2.088-1.772s-2.094-.317-2.027-1.017S157.786,209.82,157.786,209.82Z",
    transform: "translate(-98.182 -135.429)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M157.562,221.758a30.443,30.443,0,0,1-2.831-1.37A30.772,30.772,0,0,1,151.9,219a9.948,9.948,0,0,1,2.977,1.065A10.166,10.166,0,0,1,157.562,221.758Z",
    transform: "translate(-98.323 -139.02)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M161.391,218.633a22.524,22.524,0,0,1-3.653-1.181,21.965,21.965,0,0,1-3.519-1.492,22.523,22.523,0,0,1,3.653,1.181,21.963,21.963,0,0,1,3.519,1.492Z",
    transform: "translate(-99.231 -137.831)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M99.642,115.4a50.839,50.839,0,0,1-1.717-8.444,17.5,17.5,0,0,1,1.12-8.468c.177-.4,1.613-3.044,2.039-3.007.31.043-.609,2.557-.475,2.837a14.808,14.808,0,0,1,1.218,8.706,38.876,38.876,0,0,1-2.161,8.377",
    transform: "translate(-77.162 -90.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M100.625,101.944c.134-7.22,4.45-13.15,11.658-12.784l.664.073a12.894,12.894,0,0,1,11.567,13.144c-.152,6.252-.4,13.156-.791,16.48-.81,6.873-7.811,7.22-7.811,7.22l-1.6,10.6L99.59,126.441Z",
    transform: "translate(-77.859 -88.218)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M120.777,147.538a16.754,16.754,0,0,1-8.687-3.6,8.306,8.306,0,0,0,8.31,5.99Z",
    transform: "translate(-82.749 -109.655)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M134.912,119.647a.986.986,0,0,1-1.053.889.944.944,0,0,1-.919-.992.992.992,0,0,1,1.053-.895.95.95,0,0,1,.919,1Z",
    transform: "translate(-90.905 -99.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M135.074,114.476c-.134.11-.822-.517-1.881-.609s-1.887.341-1.991.2.1-.286.463-.493a2.685,2.685,0,0,1,1.613-.317,2.618,2.618,0,0,1,1.479.651C135.056,114.177,135.141,114.421,135.074,114.476Z",
    transform: "translate(-90.216 -97.644)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M120.042,118.966a.992.992,0,0,1-1.053.895.95.95,0,0,1-.919-1,.992.992,0,0,1,1.053-.864.944.944,0,0,1,.919.968Z",
    transform: "translate(-85.088 -99.505)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M117.974,113.376c-.134.116-.822-.511-1.881-.609s-1.887.341-1.991.195.1-.28.463-.487a2.685,2.685,0,0,1,1.613-.317,2.618,2.618,0,0,1,1.479.651C117.956,113.083,118.041,113.327,117.974,113.376Z",
    transform: "translate(-83.526 -97.214)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M125.31,122.49a6.733,6.733,0,0,1,1.753-.128c.268,0,.53,0,.609-.207a1.388,1.388,0,0,0-.1-.822L127,119.19a33.051,33.051,0,0,1-1.218-5.57,35.335,35.335,0,0,1,1.674,5.479c.189.749.371,1.467.548,2.149a1.583,1.583,0,0,1,0,1.078.676.676,0,0,1-.481.347,1.826,1.826,0,0,1-.469,0A7.141,7.141,0,0,1,125.31,122.49Z",
    transform: "translate(-87.921 -97.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M119.914,128.85c.17,0,.055,1.157.95,2.076s2.131.919,2.125,1.084-.3.195-.816.152a2.855,2.855,0,0,1-1.778-.84,2.484,2.484,0,0,1-.724-1.729C119.676,129.105,119.834,128.838,119.914,128.85Z",
    transform: "translate(-85.714 -103.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    d: "M117.994,106.468c-.134.274-1.175,0-2.435.049s-2.3.25-2.435,0c-.061-.134.146-.384.609-.609a4.042,4.042,0,0,1,1.826-.438,4.085,4.085,0,0,1,1.826.42C117.847,106.085,118.054,106.334,117.994,106.468Z",
    transform: "translate(-83.149 -94.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M135.169,108.57c-.213.219-.913-.1-1.79-.207s-1.632,0-1.778-.28c-.061-.128.079-.359.426-.554a2.508,2.508,0,0,1,1.5-.237,2.435,2.435,0,0,1,1.382.609C135.187,108.205,135.266,108.461,135.169,108.57Z",
    transform: "translate(-90.377 -95.307)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    d: "M98.15,118.38c-.116-.067-4.584-1.9-4.931,2.825s4.468,4.1,4.487,3.963S98.15,118.38,98.15,118.38Z",
    transform: "translate(-75.359 -99.497)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M97.167,124.212a1.333,1.333,0,0,1-.231.11.846.846,0,0,1-.609-.037,2.054,2.054,0,0,1-.81-1.893,2.812,2.812,0,0,1,.317-1.163.95.95,0,0,1,.67-.609.414.414,0,0,1,.469.262c.055.134,0,.225.043.237s.1-.073.079-.268a.524.524,0,0,0-.164-.31.609.609,0,0,0-.444-.152,1.138,1.138,0,0,0-.913.67,2.837,2.837,0,0,0-.384,1.291,2.151,2.151,0,0,0,1.053,2.131.877.877,0,0,0,.761-.073C97.155,124.328,97.185,124.224,97.167,124.212Z",
    transform: "translate(-76.136 -100.441)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    d: "M121.3,93.721c.791-.371-1.345-3-3.172-3.969-2.758-1.473-7.044-2.545-9.74-1.972-3.214.694-5.936,2.094-7.7,4.87a18.629,18.629,0,0,0-2.7,9.357,5.656,5.656,0,0,0,.481,2.934c.609,1.084,1.826,1.826,1.668,3.263a1.985,1.985,0,0,0,.4,1.473c.81.98,1.918.183,2.466-.651a13.786,13.786,0,0,0,1.644-6.088,13.844,13.844,0,0,0,0-4.511c-.183-.8-.505-1.571-.609-2.386a2.843,2.843,0,0,1,.487-2.338,2.946,2.946,0,0,1,.408-.359,4.937,4.937,0,0,1,4.949-.609c2.6,1.114,7.056,2.813,8.3,1.985a7.27,7.27,0,0,0,2.252-2.009Z",
    transform: "translate(-77.221 -87.623)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionLoading);
export default __webpack_public_path__ + "static/media/prescription_loading.c923cbaa4ecfbfd5a9ef6994391c9535.svg";
export { ForwardRef as ReactComponent };